import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import common from './locales/fr/common.json'
import auth from './locales/fr/auth.json'
import dashboard from './locales/fr/dashboard.json'
import sites from './locales/fr/sites.json'
import adsAccounts from './locales/fr/adsAccounts.json'
import bindings from './locales/fr/bindings.json'
import proposals from './locales/fr/proposals.json'

export const namespaces = [
  'common',
  'auth',
  'dashboard',
  'sites',
  'adsAccounts',
  'bindings',
  'proposals',
] as const

void i18n.use(initReactI18next).init({
  lng: 'fr',
  fallbackLng: 'fr',
  defaultNS: 'common',
  ns: namespaces,
  resources: {
    fr: {
      common,
      auth,
      dashboard,
      sites,
      adsAccounts,
      bindings,
      proposals,
    },
  },
  interpolation: { escapeValue: false },
  returnNull: false,
})

export default i18n
